// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"dd585611","232":"2cd4f7e7","237":"4cf2b85e","526":"8b10f331","787":"dbbd0357","872":"cb81985f"}[chunkId] + ".chunk.js";
};